import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=d41d09bc&scoped=true"
import script from "./changelog.vue?vue&type=script&lang=js"
export * from "./changelog.vue?vue&type=script&lang=js"
import style0 from "./changelog.vue?vue&type=style&index=0&id=d41d09bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41d09bc",
  null
  
)

export default component.exports